import { render, staticRenderFns } from "./BirIsinYapilmasiVeyaYapilmamasiAlacakFormWizard.vue?vue&type=template&id=1e113e2b"
import script from "./BirIsinYapilmasiVeyaYapilmamasiAlacakFormWizard.vue?vue&type=script&lang=ts"
export * from "./BirIsinYapilmasiVeyaYapilmamasiAlacakFormWizard.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports